/*****************************************

HTML5 Audio Player

指定したエレメントに記載されたmp3を読んで再生・一時停止するだけ
MPEG-DASHを使う場合は dash.js が必要。

## Usage

```:html
準備
<button class="js-audio-play" data-audio-src="hoge.mp3">再生</button>
再生中
<button class="js-audio-play" data-audio-src="hoge.mp3" data-audio-isplaying="true">再生</button>
```

```:javascript
var CaracolAudioPlayer = require('./caracol2/media/audio_player.js');
var audio_player = new CaracolAudioPlayer('.js-audio-play');
```

2017.03.10 ver 1.0
    ・とりあえず作った

*****************************************/

var CaracolAudoiPlayer;

module.exports = CaracolAudoiPlayer = function( target ){
    'use strict';

    this.is_autoplay = false;    // 自動再生するか
    this.is_playing = false;    // 再生中か

    this.$now_element = null;   // 現在再生中のボタン
    this.audio = null;          // <audio>エレメント

    this.is_can_play_hds = null;   // HDSを再生できるか
    this.is_can_play_hls = null;   // HLSを再生できるか
    this.is_support_mse = null;    // MedisSourceExtensionに対応しているか
    this.is_streaming = null;       // 押されたボタンのソースはストリーミング指定されているか
    this.dash_player = null;        // MPEG-DASH のプレイヤー（dash.js）

    var self = this;
    _init();

    /***********************
     * 初期化
     */
    function _init() {
        // HTML5 Audioエレメント生成
        self.audio = new Audio();

        // 再生終了イベント
        self.audio.addEventListener('ended', stop_sound);

        // 再生ボタンクリック
        $(target).on('click', _sound_btn_click);
    }

    /**************
     * 再生ボタンクリック
     * @this btn element
     */
    function _sound_btn_click() {
        // ストリーミングか
        self.is_streaming = $(this).data('audio-streaming') == true ? true : false;

        try {
            if (self.is_can_play_hds === null && self.is_streaming) {
                // ストリーミング設定なら環境チェック（初回のみ）
                self.is_can_play_hls = _is_can_play_hls();
                self.is_can_play_hds = _is_can_play_hds();
                self.is_support_mse = _is_support_mse();
            }
        } catch (e) {
            alert(e);
        }

        if (self.is_streaming && !self.is_can_play_hds && !self.is_can_play_hls && !self.is_support_mse) {
            // ストリーミングで、どの方式も対応していなければ抜ける
            return false;
        }

        if( self.$now_element && this === self.$now_element.get(0)){
            // 再生中＆現在アクティブなボタンと同一なら一時停止
            _pause_sound();
        }else{
            // 新規再生
            _play_new_sound(this);
        }
        return false;
    }

    /**************
    * 一時停止
    */
    function _pause_sound(){
        if( self.is_playing ){
            self.audio.pause();
            _change_is_playing(false);
        }else{
            self.audio.play();
            _change_is_playing(true);
        }
    }

    /**************
    * 再生終了
    */
    function stop_sound(){
        _change_is_playing(false);
        self.$now_element = null;
    }

    /**************
    * 新規再生
    */
    function _play_new_sound (elm){
        // 再生中のものがあれば停止
        if(self.$now_element){
            self.audio.pause();
            _change_is_playing(false);
        }

        self.$now_element = $(elm);

        var base = self.$now_element.data('audio-src');
        // メディアごとの再生設定
        _set_src_to_player(base);

        self.audio.load();
        self.audio.play();
        _change_is_playing(true);
    }

    /**************
    * オーディオソースを取得
    */
    function _set_src_to_player(base) {

        if (!self.is_streaming) {
            self.audio.src = base;

        } else if (self.is_can_play_hls) {
            self.audio.src = "http://" + base + "/playlist.m3u8";

        } else if (self.is_can_play_hds) {
            self.audio.src = "http://" + base + "/manifest.f4m";

        } else if (self.is_support_mse) {
            _use_dash_player(base);
        }
    }

    /**************
    * dasj.js をプレイヤーにする
    */
    function _use_dash_player(base) {
        var url = "http://" + base + "/manifest.mpd";

        if (self.dash_player === null) {
            // プレイヤー初期化
            self.dash_player = dashjs.MediaPlayer().create();
            self.dash_player.initialize(self.audio, url, self.is_autoplay);
        } else {
            self.dash_player.attachSource(url);
        }
        return
    }

    /**************
    * HLSを再生できるか
    */
    function _is_can_play_hls() {
        return self.audio.canPlayType("application/vnd.apple.mpegURL") == "maybe" ? true : false;
    }

    /**************
    * HDSを再生できるか
    */
    function _is_can_play_hds() {
        return self.audio.canPlayType("application/f4m+xml") == "maybe" ? true : false;
    }

    /**************
    * MediaSourceExtensionに対応しているか
    */
    function _is_support_mse() {
        var hasWebKit = (window.WebKitMediaSource !== null && window.WebKitMediaSource !== void 0);
        var hasMediaSource = (window.MediaSource !== null && window.MediaSource !== void 0);
        return (hasWebKit || hasMediaSource);
    }

    /**************
    * 再生状態変更
    */
    function _change_is_playing( bool ){
        self.$now_element.attr('data-audio-isplaying', bool);
        self.is_playing = bool;
    }

    function log(msg) {
        var i;
        for (i = 0; i < arguments.length; i++) {
            console.log(arguments[i]);
        }
    }

};

